module.exports = __webpack_public_path__ + "img/i_h_like_off.0cf6ee4c.svg";